import {NgModule} from "@angular/core";
import {BodyService} from "./body.service";

@NgModule({
  declarations: [],
  exports: [],
  providers: [BodyService]
})
export class UtilsModule{
  static forRoot(){
    return {
      ngModule: UtilsModule,
      providers: [BodyService]
    }
  }
}
